import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import dayjs from "dayjs";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import { AutoCompleteOption } from "../common/AutoComplete";
import { useHasScope } from "../../../../config/globalConfig";

interface Props {
    listStatusSpecial: AutoCompleteOption[];
    blockType: string;
    fromDate: string | null;
    toDate?: string | null;
    reserved?: boolean;
    restricted?: boolean;
    manuallyRemovable?: boolean;
    onDeleteBlock : () => void;
}

const VehicleAvailabilityBlock = (props: Props) => {
    const t = useOperationTranslation();
	const hasScope = useHasScope;


    const onDelete = () => {
        props.onDeleteBlock();
    }

    const isDisabled = () => {
        if ((props.reserved || (props.restricted && !hasScope("SCOPE_UPSERT_RESTRICTED_UNAVAILABILITIES"))) && !props.manuallyRemovable)
            return true;
        else
            return false;
    }


    const blockDescr = props.listStatusSpecial.find(element => element.value === props.blockType)?.label;

    // const dateFormat = "DD/MM/YYYY HH:mm";
    const dateFormat = "DD/MM/YYYY HH:mm";
    return(
        <Mui.Box bgcolor="#DBE4E9" borderRadius="5px" mt="40px"> 
            <Mui.Grid container alignItems="center" p="10px">
                <Mui.Grid item md={11} xs={11}>
                    <Mui.Grid container>
                        <Mui.Grid item xs={12} display="flex">
                            <Mui.Typography variant="body1" pr="5px">
                                {t("vehicleAvailability.status.currentState.blockLabels.causale")}
                            </Mui.Typography>

                            <Mui.Typography variant="h5">
                                {blockDescr}
                            </Mui.Typography>
                        </Mui.Grid>

                        <Mui.Grid item xs={12} display="flex">
                            <Mui.Typography variant="body1" pr="5px">
                                {t("vehicleAvailability.status.currentState.blockLabels.block")}
                            </Mui.Typography>
                            
                            <Mui.Typography variant="h5">
                                {`
                                    ${t("vehicleAvailability.status.currentState.blockLabels.from")} ${dayjs(props.fromDate).format(dateFormat)}
                                    ${props.toDate ? `${t("vehicleAvailability.status.currentState.blockLabels.to")} ${dayjs(props.toDate).format(dateFormat)}` : ""}
                                `}
                            </Mui.Typography>
                        </Mui.Grid>
                    </Mui.Grid>
                </Mui.Grid>

                <Mui.Grid item md={1} xs={1}>
                    <Mui.IconButton color='accent' onClick={onDelete} disabled={isDisabled()}>
                        <MuiIcons.Delete />
                    </Mui.IconButton>
                </Mui.Grid>
            </Mui.Grid>  
        </Mui.Box>
    )
}

export default VehicleAvailabilityBlock;